import { useSearchParams } from "react-router-dom";

import { mergeObjects } from "./utils";

/**
 * Custom hook that provides utility functions for navigation.
 *
 * @returns An object containing navigation utility functions.
 */
export const useNavigationUtils = () => {
	const [searchParams, setSearchParams] = useSearchParams();

	/**
	 * Merges the current search parameters with the provided update and sets the new search parameters.
	 *
	 * @param update - An object containing the search parameters to update.
	 * @param options - An optional object containing the following properties:
	 *   @property replace - A boolean indicating whether to replace the current entry in the history stack (default is false).
	 */
	const mergeSearchParameters = (update: Record<string, unknown>, options: { replace: boolean } | undefined) => {
		const { replace = false } = options || {};

		const currentParams = Object.fromEntries(searchParams.entries());
		const nextParams = mergeObjects(currentParams, update);

		setSearchParams(nextParams, { replace });
	};

	return {
		mergeSearchParameters,
	};
};
